import { Component, OnInit, } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from '@angular/fire/firestore';
import {Observable}from 'rxjs/Observable';
import 'rxjs/add/operator/map';

interface feedback{
name:string;
email:string;
feedback:string;
}
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
    feedbackscol:AngularFirestoreCollection<feedback>;
    feedbacks:Observable<feedback[]>;
  constructor(private afs:AngularFirestore) {
    }

  ngOnInit(){
    this.feedbackscol=this.afs.collection("feedbacks",res =>{
      return res.orderBy('createdAt', 'desc')
    });
    this.feedbacks=this.feedbackscol.valueChanges();

  }
  
}



// WEBPACK FOOTER //
// ./src/app/feedback/feedback.component.ts